import { isAllowedUri, normalizeLink } from "./utils";
export function linkMarkSpec() {
    return {
        link: {
            attrs: {
                href: {},
            },
            content: "inline+",
            inclusive: false,
            parseDOM: [
                {
                    tag: "a[href]",
                    getAttrs(dom) {
                        return { href: dom.getAttribute("href") };
                    },
                },
            ],
            toDOM(node) {
                const { href } = node.attrs;
                if (!isAllowedUri(href)) {
                    return ["span", {}, 0];
                }
                return [
                    "a",
                    {
                        href: normalizeLink(href),
                        target: "_blank",
                    },
                    0,
                ];
            },
        },
    };
}
